<div class="content content-fixed">
  <div>
    <div class="container">
      <div class="mb-3 w-full page-title-box d-sm-flex items-center justify-between">
        <h3 class="mb-0 flex gap-2 w-40">Candidate List</h3>
        <div class="mb-3 flex gap-2 w-full justify-end">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (ngModelChange)="filterCandidates()"
            placeholder="Search by ID, name, or email"
            class="w-96 h-10 border-2 border-gray-200 pl-2 mr-5.5"
            style="width: 400px"
          />
          <label class="flex items-center -scroll-mr-16">
            <input type="checkbox" [(ngModel)]="isChecked" (click)="toggleIncludeDelete()" class="mr-2 mb-1" />
            <span class="mr-3">Include Deleted</span>
          </label>
          <button
            class="btn btn-sm btn-default btn-uppercase"
            (click)="openIdvOnlyModal()"
          >
            <i data-feather="mail" class="mr-1 mt-1"></i>
            <p class="mt-0.5">IDV + Disclosure</p>
          </button>
          <button
            class="btn btn-sm btn-default btn-uppercase"
            data-toggle="modal"
            data-target="#addUser"
            (click)="openFormModal()"
          >
            <i data-feather="plus-circle" class="mr-1 mt-1"></i>
            <p class="mt-0.5">Manual Screening</p>
          </button>
        </div>
      </div>

      <!-- Display error message if any -->
      <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <!-- Display the list of candidates if available -->
      <div class="assessment_order">
        <div class="table-container">
          <table class="table table-striped">
            <thead>
              <tr>
                <th *ngFor="let header of headers" (click)="header.sortable && changeSort(header.field)">
                  {{ header.label }}
                  <span *ngIf="sortField === header.field">{{ sortDirection === 1 ? '↑' : '↓' }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of tableBodyData; trackBy: trackByFn">
                <td *ngFor="let header of headers">
                  <ng-container *ngIf="header.field !== 'actions' && header.field !== 'candidateImage'">
                    {{ row[header.field] }}
                  </ng-container>
                  <ng-container *ngIf="header.field === 'candidateImage'">
                    <img [src]="row[header.field]" [alt]="row.name" class="object-cover" width="50" height="50" />
                  </ng-container>
                  <ng-container *ngIf="header.field === 'actions'" class="gap-2 flex">
                    <button
                      (click)="onInvestigateAndCheck(row)"
                      class="btn btn-sm btn-uppercase btn-default justify-center flex items-center confirm w-24"
                      [disabled]="isLoading"
                    >
                      <i class="fas fa-folder-open text-base iconbg"></i>
                      <i class="fas fa-search -ml-2 -mb-1 dual-color-icon text-xl"></i>
                    </button>
                    <button
                      (click)="confirmDelete(row)"
                      [disabled]="row.is_deleted === true || isLoading"
                      class="btn btn-sm btn-uppercase btn-default justify-center flex items-center h-6 deleted py-3"
                    >
                      <i class="fas fa-trash-alt text-lg"></i>
                    </button>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="noDataFound" style="color: rgb(6, 6, 6); text-align: center">No data found.</div>
        </div>
        <ng-template>
          <div *ngIf="error; else loading">
            <p>{{ error }}</p>
          </div>
        </ng-template>

        <ng-template #loading>
          <p>Loading...</p>
        </ng-template>

        <app-spinner *ngIf="isLoading" class="loading-overlay"></app-spinner>
      </div>

      <div class="pagination container mt-auto">
        <div class="pagination-controls">
          <button
            class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center"
            (click)="goToFirstPage()"
            [disabled]="currentPage === 1"
          >
            <i class="fa fa-fast-backward" aria-hidden="true"></i>
          </button>

          <button
            class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
          >
            <i class="fa fa-step-backward" aria-hidden="true"></i>
          </button>

          <span class="mt-2 bt-3">Page {{ currentPage }} of {{ totalPages }}</span>

          <button
            class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center"
            (click)="nextPage()"
            [disabled]="currentPage >= totalPages"
          >
            <i class="fa fa-step-forward" aria-hidden="true"></i>
          </button>

          <button
            class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center"
            (click)="goToLastPage()"
            [disabled]="currentPage === totalPages"
          >
            <i class="fa fa-fast-forward" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <!-- Delete Modal -->
      <div *ngIf="showDeleteModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-gray-200 py-2 rounded-lg shadow-lg w-auto max-w-md">
          <div class="flex justify-between px-2">
            <h1 class="font-semibold text-lg text-gray-800 px-2">Delete Confirmation</h1>
            <p class=" top-0 cursor-pointer"  (click)="cancelDelete()">
              x
            </p>
          </div>
          
          <p class="text-gray-600 mt-2  px-2">Are you sure you want to delete {{ candidateToDelete?.name }} ?</p>
      
          <div class="flex justify-end mt-4 space-x-3  px-2">
            <button (click)="cancelDelete()" class="btn mx-2">Cancel</button>
            <button (click)="performDelete()" class="btn btn-primary mx-2">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showFormModal" class="modal">
    <div class="modal-content w-[70%] max-w-[1600px]">
      <div class="justify-between flex items-center pt-0.5 px-3" style="border-bottom: 1px solid #a5a3a3">
        <p class="my-1 pt-2 pl-2 text-sm pb-1">Manual Screening</p>
        <div
          type="button"
          class="close absolute right-0 pr-3"
          data-dismiss="modal"
          aria-label="Close"
          (click)="cancelForm()"
          #closeUser
        >
          <span aria-hidden="true">×</span>
        </div>
      </div>
      <div class="text-red-600 font-semibold text-opacity-75">{{ errorMS }}</div>
      <form (ngSubmit)="submitForm()">
        <div class="grid grid-cols-2 gap-6 bg-white pl-8 pr-8 pt-3 pb-3">
          <div *ngFor="let field of formFields; let i = index" class="w-full flex flex-col">
            <label class="w-full flex"
              >{{ field.label }}
              <p class="text-red-500 ml-1" *ngIf="field.show?.includes(bgPlanData)">*</p></label
            >
            <div *ngIf="field.name === 'assessmentPackageId'">
              <select
                id="decisionDropdown"
                [(ngModel)]="formData[field.name]"
                name="{{ field.name }}"
                class="form-control"
                (change)="bgPlan($event.target.value)"
              >
                <option *ngFor="let option of decisionOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div *ngIf="field.name === 'assessment_source'">
              <select
                id="decisionDropdown"
                [disabled]="!field.show?.includes(bgPlanData)"
                class="form-control"
                (change)="assessmentOption($event.target.value)"
              >
                <option *ngFor="let option of assessmentOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <input
              #dobInput
              *ngIf="field.name !== 'assessmentPackageId' && field.name !== 'assessment_source'"
              type="text"
              [(ngModel)]="formData[field.name]"
              [name]="field.name"
              [type]="field.name === 'date_of_birth' ? 'date' : 'text'"
              [maxlength]="field.name === 'date_of_birth' ? 10 : field.name === 'phoneNumber' ? 12 : 40"
              (change)="field.name === 'date_of_birth' ? onDateChange($event) : null"
              (input)="validateNumberField($event, field.name)"
              [disabled]="!field.show?.includes(bgPlanData)"
              class="form-control mr-2 p-3 pr-15 border border-gray-300"
            />
          </div>
        </div>
        <div class="text-center w-full flex px-2 justify-between items-center border-t border-[#a5a3a3] pt-2">
          <div class="flex gap-2 justify-center items-center w-fit h-fit">
            <input type="checkbox" name="resubmit" id="resubmit" (change)="reupdate()" />
            <label for="resubmit" class="mt-2">Create another</label>
          </div>

          <div class="flex gap-2 items-center">
            <button type="cancel" (click)="cancelForm()" class="btn mx-2">Cancel</button>
            <button class="btn btn-primary mx-2" [disabled]="btnDissble">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="showIdvOnlyModal" class="modal">
    <div class="modal-content w-[70%] max-w-[1600px]">
      <div class="justify-between flex items-center pt-0.5 px-3" style="border-bottom: 1px solid #a5a3a3">
        <p class="my-1 pt-2 pl-2 text-sm pb-1">IDV + Disclosure</p>
        <div
          type="button"
          class="close absolute right-0 pr-3"
          data-dismiss="modal"
          aria-label="Close"
          (click)="cancelIdvOnly()"
        >
          <span aria-hidden="true">×</span>
        </div>
      </div>
      <div class="text-red-600 font-semibold text-opacity-75">{{ idvOnlyErrorMS }}</div>
      <form (ngSubmit)="submitIdvOnly()">
        <div class="grid grid-cols-2 gap-6 bg-white pl-8 pr-8 pt-3 pb-3">
          <div *ngFor="let field of idvOnlyFormFields; let i = index" class="w-full flex flex-col">
            <label class="w-full flex">{{ field.label }} <p class="text-red-500 ml-1">*</p></label>
            <div *ngIf="field.name === 'assessmentPackageId'">
              <select
                [(ngModel)]="idvOnlyFormData[field.name]"
                name="{{ field.name }}"
                class="form-control"
                (change)="bgPlanIdvOnly($event.target.value)"
              >
                <option *ngFor="let option of decisionOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <input
              *ngIf="field.name !== 'assessmentPackageId'"
              type="text"
              [(ngModel)]="idvOnlyFormData[field.name]"
              [name]="field.name"
              [maxlength]="field.name === 'ssn' ? 9 : 40"
              (input)="validateIdvOnlyNumberField($event, field.name)"
              class="form-control mr-2 p-3 pr-15 border border-gray-300"
            />
          </div>
        </div>
        <div class="text-center w-full flex px-2 justify-end items-center border-t border-[#a5a3a3] pt-2">
          <div class="flex gap-2 items-center">
            <button type="button" (click)="cancelIdvOnly()" class="btn mx-2">Cancel</button>
            <button class="btn btn-primary mx-2" [disabled]="idvOnlyBtnDisable">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <app-status-messages [tosterMessage]="tosterMessage"></app-status-messages>
</div>
